import { ShieldCheck, Clock3, ReceiptText, KeyRound } from "lucide-react";
import { whyParkora } from "../content/site";
import { Container, Reveal, SectionHeading, Stagger, StaggerItem } from "./ui";

const ICONS = [ShieldCheck, Clock3, ReceiptText, KeyRound];

export default function WhyParkora() {
  return (
    <section id="why-parkora" className="bg-white py-20 sm:py-28">
      <Container>
        <Reveal>
          <SectionHeading title={whyParkora.headline} />
        </Reveal>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {whyParkora.features.map((f, idx) => {
            const Icon = ICONS[idx];
            return (
              <StaggerItem key={f.title}>
                <div className="h-full rounded-3xl border border-navy/8 bg-[var(--color-bg-soft)] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-primary/20 hover:shadow-navy">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--color-bg-light-orange)] text-primary">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 text-base font-extrabold tracking-tight text-navy">
                    {f.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-navy/60">{f.text}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </Container>
    </section>
  );
}
